'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  margin-top: 10px;\n  display: flex;\n'], ['\n  width: 100%;\n  margin-top: 10px;\n  display: flex;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Pagination = require('../../Pagination/Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject);

var TablePagination = function TablePagination(_ref) {
  var props = _objectWithoutProperties(_ref, []);

  return _react2.default.createElement(Container, null, _react2.default.createElement('div', null, _react2.default.createElement(_Pagination2.default, props)));
};

exports.default = TablePagination;